import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { Link } from 'react-router-dom';
import HomeIcon from '@material-ui/icons/Home';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import StoreIcon from '@material-ui/icons/Store';
import PersonIcon from '@material-ui/icons/Person';
import StorageIcon from '@material-ui/icons/Storage';
import CategoryIcon from '@material-ui/icons/Category';
import PaymentIcon from '@material-ui/icons/Payment';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import ReceiptIcon from '@material-ui/icons/Receipt';
import InputIcon from '@material-ui/icons/Input';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import AssessmentIcon from '@material-ui/icons/Assessment';
import PublishIcon from '@material-ui/icons/Publish';
import InfoIcon from '@material-ui/icons/Info';
import SettingsIcon from '@material-ui/icons/Settings';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import RoomIcon from '@material-ui/icons/Room';
import './Header.scss';
import Dialog  from "@material-ui/core/Dialog"; 
import DialogActions from "@material-ui/core/DialogActions"; 
import DialogContent from "@material-ui/core/DialogContent"; 
import DialogContentText from "@material-ui/core/DialogContentText"; 
import DialogTitle from "@material-ui/core/DialogTitle";
import { useHistory } from 'react-router-dom';

// Release metadata (Menu → Version). Use module constants—not useState—so edits
// and hot reload always show the current values instead of first-mount state.
const APP_VERSION = '68.15';
const VERSION_DATE = '8/17/2026';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  appBar: {
    boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
  },
  toolbar: {
    minHeight: 64,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  menuButton: {
    marginRight: theme.spacing(1),
  },
  title: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
  },
  brand: {
    fontWeight: 700,
    fontSize: '1.35rem',
    letterSpacing: '-0.02em',
    color: '#fff',
  },
}));

export default function Header() {
  const history = useHistory();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [configAnchorEl, setConfigAnchorEl] = React.useState(null);
  const [inventoryAnchorEl, setInventoryAnchorEl] = React.useState(null);
  const [showConfirm, setShowConfirm] = React.useState(false);
  const [showVersion, setShowVersion] = React.useState(false);

  const userJson = sessionStorage.getItem('user');
  const user = userJson ? JSON.parse(userJson) : null;
  const permissions = user && user.permissions ? user.permissions : [];

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setConfigAnchorEl(null);
    setInventoryAnchorEl(null);
  };

  const handleConfigOpen = (event) => {
    setConfigAnchorEl(event.currentTarget);
  };

  const handleConfigClose = () => {
    setConfigAnchorEl(null);
  };

  const handleInventoryOpen = (event) => {
    setInventoryAnchorEl(event.currentTarget);
  };

  const handleInventoryClose = () => {
    setInventoryAnchorEl(null);
  };

  const handleConfirm = () => { 
		setShowConfirm(true); 
   
	}; 

  const handleVersionOpen = () => {
    setShowVersion(true);
    handleClose();
  }; 

  const handleVersionClose = () => { 
		setShowVersion(false); 
   
	}; 


  const handleNo = () => { 
		setShowConfirm(false); 
	}; 

  const handleLogout = () => {
    history.push('/logout');
  }; 

  const hasPermission = (name) =>
    permissions.some((x) => x.PermissionName === name && x.PermissionAllowed === 1);

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <Typography variant="h6" className={classes.title} component="div">
            <IconButton
              edge="start"
              className={classes.menuButton}
              color="inherit"
              onClick={handleClick}
              aria-label="menu"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
              getContentAnchorEl={null}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            >
              <Link to="home"><MenuItem onClick={handleClose} className="header__menu-item"><HomeIcon className="header__menu-item-icon" /> Home</MenuItem></Link>
              <Link to="user-dashboard"><MenuItem onClick={handleClose} className="header__menu-item"><DashboardIcon className="header__menu-item-icon" /> My Dashboard</MenuItem></Link>
              {hasPermission('Vendor') && <Link to="vendor-form"><MenuItem onClick={handleClose} className="header__menu-item"><StoreIcon className="header__menu-item-icon" /> Vendor Form</MenuItem></Link>}
              {hasPermission('Customer') && <Link to="customer-form"><MenuItem onClick={handleClose} className="header__menu-item"><PersonIcon className="header__menu-item-icon" /> Customer Form</MenuItem></Link>}
              {hasPermission('Inventory') && (
                <MenuItem
                  className="header__menu-item header__menu-item--submenu"
                  onMouseEnter={handleInventoryOpen}
                  onClick={handleInventoryOpen}
                >
                  <StorageIcon className="header__menu-item-icon" />
                  Inventory
                  <ArrowRightIcon className="header__menu-item-arrow" />
                </MenuItem>
              )}
              <Menu
                anchorEl={inventoryAnchorEl}
                open={Boolean(inventoryAnchorEl)}
                onClose={handleInventoryClose}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                MenuListProps={{ onMouseLeave: handleInventoryClose }}
              >
                {hasPermission('Inventory') && (
                  <Link to="item-form">
                    <MenuItem onClick={handleClose} className="header__menu-item">
                      <StorageIcon className="header__menu-item-icon" />
                      Inventory
                    </MenuItem>
                  </Link>
                )}
                {hasPermission('Inventory') && (
                  <Link to="inventory-transfer">
                    <MenuItem onClick={handleClose} className="header__menu-item">
                      <StorageIcon className="header__menu-item-icon" />
                      Inventory Transfer
                    </MenuItem>
                  </Link>
                )}
              </Menu>
              <MenuItem
                className="header__menu-item header__menu-item--submenu"
                onMouseEnter={handleConfigOpen}
                onClick={handleConfigOpen}
              >
                <SettingsIcon className="header__menu-item-icon" />
                Configuration
                <ArrowRightIcon className="header__menu-item-arrow" />
              </MenuItem>
              <Menu
                anchorEl={configAnchorEl}
                open={Boolean(configAnchorEl)}
                onClose={handleConfigClose}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                MenuListProps={{ onMouseLeave: handleConfigClose }}
              >
                {hasPermission('User') && (
                  <Link to="user-form">
                    <MenuItem onClick={handleClose} className="header__menu-item">
                      <SupervisedUserCircleIcon className="header__menu-item-icon" />
                      User Administration
                    </MenuItem>
                  </Link>
                )}
                {hasPermission('Payment Method') && (
                  <Link to="payment-method">
                    <MenuItem onClick={handleClose} className="header__menu-item">
                      <PaymentIcon className="header__menu-item-icon" />
                      Payment Method
                    </MenuItem>
                  </Link>
                )}
                {hasPermission('Payment Method') && (
                  <Link to="commission">
                    <MenuItem onClick={handleClose} className="header__menu-item">
                      <MonetizationOnIcon className="header__menu-item-icon" />
                      Commission
                    </MenuItem>
                  </Link>
                )}
                {hasPermission('Item Category') && (
                  <Link to="entity-group">
                    <MenuItem onClick={handleClose} className="header__menu-item">
                      <CategoryIcon className="header__menu-item-icon" />
                      Entity Groups
                    </MenuItem>
                  </Link>
                )}
                {hasPermission('Item Category') && (
                  <Link to="item-category">
                    <MenuItem onClick={handleClose} className="header__menu-item">
                      <CategoryIcon className="header__menu-item-icon" />
                      Item Category
                    </MenuItem>
                  </Link>
                )}
                {hasPermission('Inventory') && (
                  <Link to="item-location">
                    <MenuItem onClick={handleClose} className="header__menu-item">
                      <RoomIcon className="header__menu-item-icon" />
                      Item Locations
                    </MenuItem>
                  </Link>
                )}
                {hasPermission('Inventory') && (
                  <Link to="location-details">
                    <MenuItem onClick={handleClose} className="header__menu-item">
                      <RoomIcon className="header__menu-item-icon" />
                      Location Details
                    </MenuItem>
                  </Link>
                )}
                <MenuItem onClick={handleVersionOpen} className="header__menu-item">
                  <InfoIcon className="header__menu-item-icon" />
                  Version
                </MenuItem>
              </Menu>
              {hasPermission('Transaction') && <Link to="transactions"><MenuItem onClick={handleClose} className="header__menu-item"><ReceiptIcon className="header__menu-item-icon" /> Transactions</MenuItem></Link>}
              {hasPermission('InTake Product') && <Link to="intake"><MenuItem onClick={handleClose} className="header__menu-item"><InputIcon className="header__menu-item-icon" /> Product Intake</MenuItem></Link>}
              {hasPermission('Check Out Product') && <Link to="CheckOut"><MenuItem onClick={handleClose} className="header__menu-item"><ShoppingCartIcon className="header__menu-item-icon" /> Product Check Out</MenuItem></Link>}
              {hasPermission('Reports') && <Link to="reports"><MenuItem onClick={handleClose} className="header__menu-item"><AssessmentIcon className="header__menu-item-icon" /> Reports</MenuItem></Link>}
              {hasPermission('Imports') && <Link to="imports"><MenuItem onClick={handleClose} className="header__menu-item"><PublishIcon className="header__menu-item-icon" /> Imports</MenuItem></Link>}
            </Menu>
            <span className={`${classes.brand} header__brand`}>alfaSUITE</span>
          </Typography>
          <IconButton onClick={handleConfirm} color="inherit" className="header__logout-btn" aria-label="logout">
            <PowerSettingsNewIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {showConfirm && ( 
					<div> 
						<Dialog 
						open={showConfirm} 
						onClose={handleNo} 
						aria-labelledby="alert-dialog-title"
						aria-describedby="alert-dialog-description"
						> 
						<DialogTitle id="alert-dialog-title"> 
							{"Confirm Logout"} 
						</DialogTitle> 
						<DialogContent> 
							<DialogContentText id="alert-dialog-description"> 
							Are you sure to logout
							</DialogContentText> 
						</DialogContent> 
						<DialogActions> 
							<Button 
              onClick={handleLogout} 
							color="primary"
							autoFocus 
							> 
							Yes 
							</Button> 
							<Button 
							onClick={handleNo} 
							color="primary"
							autoFocus 
							> 
							No 
							</Button> 
						</DialogActions> 
						</Dialog> 
					</div> 
					)} 
      	
					{showVersion && ( 
					<div> 
						<Dialog 
						open={showVersion} 
						onClose={handleVersionClose} 
						aria-labelledby="alert-dialog-title"
						aria-describedby="alert-dialog-description"
						> 
						<DialogTitle id="alert-dialog-title"> 
							{"Application Version"} 
						</DialogTitle> 
						<DialogContent> 
							<DialogContentText id="alert-dialog-description"> 
							<div>
                Version : {APP_VERSION}
              </div>
              <div>
                Date : {VERSION_DATE}
              </div>
							</DialogContentText> 
						</DialogContent> 
						<DialogActions> 
							
							<Button 
							onClick={handleVersionClose}
							color="primary"
							autoFocus 
							> 
							Close
							</Button> 
						</DialogActions> 
						</Dialog> 
					</div> 
					)} 
    </div>
  );
}
